module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/angle-left-c0bccc5c928ac0c7372c2c79fc48c03c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/angle-left.svg
// module id = 8VDx
// module chunks = 24